import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-show-evidence',
  templateUrl: './dialog-show-evidence.component.html',
  styleUrls: ['./dialog-show-evidence.component.scss']
})
export class DialogShowEvidenceComponent implements OnInit {

  url = '';
  type = '';

  constructor(
    private readonly dialogRef: MatDialogRef<DialogShowEvidenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  ngOnInit(): void {
    this.url = this.data.url;
    this.type = this.data.type;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isPdf(type: string): boolean {
    return type.includes('pdf');
  }

  isImg(type: string): boolean {
    return type.includes('image');
  }

  isVideo(type: string): boolean {
    return type.includes('video');
  }

}
